import { useContext } from 'react';
import profileContext from 'context/profile-context';

const useProfile = () => {
  return useContext(profileContext);
};

export default useProfile;
